import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import Security from '../../../commons/security/Security.js';
import { Redirect } from 'react-router-dom';
import DisponibilidadReglasGrid from './DisponibilidadReglasGrid.jsx';
import DisponibilidadReglasAbm from './DisponibilidadReglasAbm.js';

class DisponibilidadReglas extends Component {
  render() {
    if (!Security.hasPermission('DISPONIBILIDAD_REGLAS_LISTAR')) {
      return <Redirect to="/error" />;
    }

    return (
      <div className="content-wrapper">
        <div className="content-header row">
          <div className="content-header-left col-md-6 col-12 mb-2">
            <h3 className="content-header-title">
              <FormattedMessage
                id="disponibilidadReglas.titulo"
                defaultMessage="Reglas de Rentadora"
              />
            </h3>
          </div>
        </div>
        <div className="content-body">
          <Switch>
            <Route
              exact
              path={`${this.props.match.url}`}
              component={DisponibilidadReglasGrid}
            />
            <Route
              exact
              path={`${this.props.match.url}/add`}
              render={(props) => <DisponibilidadReglasAbm {...props} action="ADD" />}
            />
            <Route
              exact
              path={`${this.props.match.url}/:id/edit`}
              render={(props) => <DisponibilidadReglasAbm {...props} action="EDIT" />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default injectIntl(DisponibilidadReglas);
